export default "__VITE_ASSET__CGwBue1p__"